import { RouteRecordRaw } from 'vue-router';
import { requireAuth, setDayjsTimezone } from '@/common/router/navigationGuard';
import { ROLE_PERMISSION_KEY } from '@/common/define/rolePermission.define';
import { extractAccessibleRoutes } from '@/common/auth/auth.utils';
import BaseViewport from '@/common/components/templates/baseViewport/BaseViewport.vue';
import { VIEWPORT_TYPE } from '@/common/components/templates/baseViewport/baseViewport.define';

const PREFIX_BUSINESS = 'business_';

const businessMenu: RouteRecordRaw[] = [
  {
    path: '/business/',
    name: `${PREFIX_BUSINESS}Business`,
    component: BaseViewport,
    meta: {
      rolePermission: ROLE_PERMISSION_KEY.MONITORING.MONITORING_BUSINESS,
      viewport: VIEWPORT_TYPE.REALTIME,
    },
    children: [
      {
        path: 'list',
        name: `${PREFIX_BUSINESS}Business List`,
        component: () => import('@/service/views/serviceView/ServiceView.vue'),
        beforeEnter: [requireAuth, setDayjsTimezone],
        meta: {
          rolePermission: ROLE_PERMISSION_KEY.MONITORING.MONITORING_BUSINESS_LIST,
        },
      },
      {
        path: 'map',
        name: `${PREFIX_BUSINESS}Business Map`,
        component: () => import('@/service/views/businessMap/BusinessMap.vue'),
        beforeEnter: [requireAuth, setDayjsTimezone],
        meta: {
          rolePermission: ROLE_PERMISSION_KEY.MONITORING.MONITORING_BUSINESS_MAP,
        },
      },
    ],
  },
];

const getBusinessNaviMenu = () => {
  const filteredBusinessMenu = extractAccessibleRoutes(businessMenu);

  return [...filteredBusinessMenu];
};

export { businessMenu, getBusinessNaviMenu };
